(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-carousel]').forEach((root) => {
    if (root.dataset.carouselReady) return;
    root.dataset.carouselReady = 'true';
    const track = root.querySelector('[data-carousel-track]');
    const prev = root.querySelector('[data-carousel-prev]');
    const next = root.querySelector('[data-carousel-next]');
    const thumb = root.querySelector('[data-carousel-thumb]');
    const step = () => track.querySelector('.seed-fc-carousel-slide').getBoundingClientRect().width;
    const update = () => {
      const max = track.scrollWidth - track.clientWidth - 1;
      prev.disabled = track.scrollLeft <= 0;
      next.disabled = track.scrollLeft >= max;
      const ratio = track.scrollWidth ? Math.min(1, track.clientWidth / track.scrollWidth) : 1;
      const progress = max > 0 ? Math.min(1, Math.max(0, track.scrollLeft / max)) : 0;
      thumb.style.width = ratio * 100 + '%';
      thumb.style.transform = 'translateX(' + (progress * (1 / ratio - 1) * 100) + '%)';
    };
    prev.addEventListener('click', () => track.scrollBy({left: -step(), behavior: 'smooth'}));
    next.addEventListener('click', () => track.scrollBy({left: step(), behavior: 'smooth'}));
    track.addEventListener('scroll', update, {passive: true});
    window.addEventListener('resize', update);
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["founder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-founder-video]').forEach((video) => {
      const button = video.parentElement.querySelector('[data-founder-play]');
      let near = false;
      let userPaused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const syncButton = () => {
        const playing = !video.paused;
        button.hidden = false;
        button.classList.toggle('seed-founder-play--playing', playing);
        button.setAttribute('aria-label', playing ? button.dataset.labelPause : button.dataset.labelPlay);
        button.querySelector('[data-founder-icon-play]').toggleAttribute('hidden', playing);
        button.querySelector('[data-founder-icon-pause]').toggleAttribute('hidden', !playing);
      };
      const isNear = () => {
        const rect = video.getBoundingClientRect();
        return rect.top < window.innerHeight && rect.bottom > 0;
      };
      const play = () => {
        if (document.hidden || !near || userPaused || !video.paused) return;
        if (!video.hasAttribute('src')) video.src = video.dataset.src;
        video.muted = true;
        video.play().catch(syncButton);
      };
      const syncVisibility = () => {
        near = isNear();
        if (!near || document.hidden) video.pause();
        else play();
      };
      button.addEventListener('click', () => {
        if (video.paused) { userPaused = false; near = isNear(); play(); }
        else { userPaused = true; video.pause(); }
      });
      video.addEventListener('playing', syncButton);
      video.addEventListener('pause', syncButton);
      video.addEventListener('error', syncButton);
      video.addEventListener('canplay', play);
      document.addEventListener('visibilitychange', syncVisibility);
      window.addEventListener('pageshow', syncVisibility);
      window.addEventListener('scroll', syncVisibility, {passive:true});
      if ('IntersectionObserver' in window) new IntersectionObserver(syncVisibility).observe(video);
      syncButton();
      syncVisibility();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SCROLL_OFFSET = 24;
    const ROTATE_MS = 5000;

    class SeedHeader {
      constructor() {
        this.nav = document.querySelector('[data-nav]');
        if (!this.nav) return;

        this.bar = document.querySelector('[data-announcement-bar]');
        this.mobilePanel = this.nav.querySelector('#MobileMenu');
        this.mobileToggle = this.nav.querySelector('[data-mobile-toggle]');
        this.searchRoot = this.nav.querySelector('[data-nav-search]');
        this.leftPill = this.nav.querySelector('[data-nav-left]');
        this.rightPill = this.nav.querySelector('[data-nav-right]');
        this.searchOpen = false;
        this.slideIndex = 0;
        this.paused = false;
        // Light nav over any page whose first section is dark, not just when the setting is on
        this.isDark =
          this.nav.dataset.dark === 'true' ||
          Boolean(document.querySelector('#main-content > .shopify-section:first-child > :first-child.seed-section-dark'));

        this.bindScroll();
        this.bindAnnouncements();
        this.bindDropdowns();
        this.bindMobileMenu();
        this.bindSearch();
        this.bindCart();
      }

      bindScroll() {
        const update = () => {
          const scrolled = window.scrollY > SCROLL_OFFSET;
          this.nav.classList.toggle('seed-nav--scrolled', scrolled);
          this.nav.classList.toggle('seed-nav--dark', this.isDark && !scrolled);
          if (this.bar) this.bar.classList.toggle('seed-announcement-bar--hidden', scrolled);
        };
        window.addEventListener('scroll', update, { passive: true });
        update();
      }

      bindAnnouncements() {
        if (!this.bar) return;
        const slides = [...this.bar.querySelectorAll('[data-announcement-slide]')];
        if (slides.length < 2) return;

        const show = (next) => {
          this.slideIndex = (next + slides.length) % slides.length;
          slides.forEach((slide, i) => {
            slide.hidden = i !== this.slideIndex;
          });
        };

        this.bar.querySelector('[data-announcement-prev]').addEventListener('click', () => {
          this.paused = true;
          show(this.slideIndex - 1);
        });
        this.bar.querySelector('[data-announcement-next]').addEventListener('click', () => {
          this.paused = true;
          show(this.slideIndex + 1);
        });
        this.bar.addEventListener('mouseenter', () => (this.paused = true));
        this.bar.addEventListener('mouseleave', () => (this.paused = false));
        this.bar.addEventListener('focusin', () => (this.paused = true));
        this.bar.addEventListener('focusout', () => (this.paused = false));

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        setInterval(() => {
          if (!this.paused) show(this.slideIndex + 1);
        }, ROTATE_MS);
      }

      bindDropdowns() {
        this.nav.querySelectorAll('[data-nav-dropdown]').forEach((item) => {
          const button = item.querySelector('.seed-nav-problems-chevron-btn');
          const menu = item.querySelector('.seed-nav-problems-dropdown');
          const chevron = item.querySelector('.seed-nav-problems-chevron');

          const setOpen = (open) => {
            button.setAttribute('aria-expanded', String(open));
            menu.hidden = !open;
            chevron.classList.toggle('seed-nav-problems-chevron--open', open);
          };

          button.addEventListener('click', () => setOpen(menu.hidden));
          let closeTimer;
          item.addEventListener('mouseenter', () => {
            clearTimeout(closeTimer);
            setOpen(true);
          });
          item.addEventListener('mouseleave', () => {
            clearTimeout(closeTimer);
            closeTimer = setTimeout(() => setOpen(false), 150);
          });
          item.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
              setOpen(false);
              button.focus();
            }
          });
          item.addEventListener('focusout', (event) => {
            if (!item.contains(event.relatedTarget)) setOpen(false);
          });
        });
      }

      bindMobileMenu() {
        const openIcon = this.mobileToggle.querySelector('[data-icon-open]');
        const closeIcon = this.mobileToggle.querySelector('[data-icon-close]');

        this.mobileToggle.addEventListener('click', () => {
          const open = this.mobilePanel.hidden;
          this.mobilePanel.hidden = !open;
          this.mobileToggle.setAttribute('aria-expanded', String(open));
          this.mobileToggle.setAttribute(
            'aria-label',
            open ? this.mobileToggle.dataset.closeLabel : this.mobileToggle.dataset.openLabel,
          );
          openIcon.hidden = open;
          closeIcon.hidden = !open;
        });

        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && !this.mobilePanel.hidden) {
            this.mobileToggle.click();
            this.mobileToggle.focus();
          }
        });
      }

      bindSearch() {
        const toggle = this.searchRoot.querySelector('[data-search-toggle]');
        const template = this.searchRoot.querySelector('[data-search-template]');
        let debounce;

        const close = () => {
          this.searchOpen = false;
          this.searchRoot.querySelectorAll('.seed-nav-search-backdrop, .seed-nav-search-sheet').forEach((el) => el.remove());
          this.leftPill.classList.remove('seed-nav-left-pill--hidden');
          this.rightPill.classList.remove('seed-nav-right-pill--search-open');
          toggle.setAttribute('aria-expanded', 'false');
          toggle.focus();
        };

        const open = () => {
          this.searchOpen = true;
          this.searchRoot.append(template.content.cloneNode(true));
          this.leftPill.classList.add('seed-nav-left-pill--hidden');
          this.rightPill.classList.add('seed-nav-right-pill--search-open');
          toggle.setAttribute('aria-expanded', 'true');

          const input = this.searchRoot.querySelector('[data-search-input]');
          const results = this.searchRoot.querySelector('[data-search-results]');
          input.focus();

          input.addEventListener('input', () => {
            clearTimeout(debounce);
            const term = input.value.trim();
            // Hydrogen's /search?predictive returns nothing below 3 characters
            // (term.length < 3), so results start once the term passes 2.
            if (term.length <= 2) {
              results.innerHTML = '';
              return;
            }
            debounce = setTimeout(async () => {
              // Title-only matching, like Hydrogen's toTitleScopedQuery; 10 per type
              // (limit_scope=each), of which the dropdown shows 4 products / 3 articles.
              const params = new URLSearchParams({
                q: term,
                'resources[type]': 'product,article',
                'resources[limit]': '10',
                'resources[limit_scope]': 'each',
                'resources[options][fields]': 'title',
                section_id: 'predictive-search',
              });
              try {
                const response = await fetch(`${window.Shopify.routes.root}search/suggest?${params}`);
                if (!response.ok || input.value.trim() !== term) return;
                const markup = new DOMParser().parseFromString(await response.text(), 'text/html');
                const section = markup.querySelector('#shopify-section-predictive-search');
                results.innerHTML = section ? section.innerHTML : '';
              } catch (_) {
                // Offline or aborted: keep the last results; Enter still submits to /search.
              }
            }, 250);
          });

          this.searchRoot.querySelectorAll('[data-search-close]').forEach((el) => el.addEventListener('click', close));
        };

        toggle.addEventListener('click', () => (this.searchOpen ? close() : open()));
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.searchOpen) close();
        });
        document.addEventListener('mousedown', (event) => {
          if (this.searchOpen && !this.searchRoot.contains(event.target)) close();
        });
      }

      bindCart() {
        document.addEventListener('cart:updated', (event) => {
          const badge = this.nav.querySelector('[data-cart-count]');
          const count = event.detail.cart.item_count;
          badge.textContent = count;
          badge.hidden = count === 0;
        });
      }
    }

    new SeedHeader();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const AUTOPLAY_MS = 6000;
    const SWIPE_PX = 50;

    document.querySelectorAll('[data-hero-slider]').forEach((slider) => {
      const slides = [...slider.querySelectorAll('[data-hero-slide]')];
      const dots = [...slider.querySelectorAll('[data-hero-dot]')];
      if (slides.length < 2) return;

      let index = 0;
      let paused = false;
      let touchStart = null;
      let navigation = 0;

      const goTo = async (next) => {
        const target = (next + slides.length) % slides.length;
        const request = ++navigation;
        const deferred = slides[target].querySelector('[data-hero-picture]');
        if (deferred) deferred.replaceWith(deferred.content.cloneNode(true));
        const image = slides[target].querySelector('.seed-hero-image');
        if (image && !image.complete) {
          await new Promise((resolve) => {
            image.addEventListener('load', resolve, { once: true });
            image.addEventListener('error', resolve, { once: true });
            if (image.complete) resolve();
          });
        }
        if (request !== navigation) return;
        index = target;
        slides.forEach((slide, i) => {
          const active = i === index;
          slide.classList.toggle('seed-hero-slide--active', active);
          slide.toggleAttribute('inert', !active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        dots.forEach((dot, i) => {
          dot.classList.toggle('seed-hero-dot--active', i === index);
          dot.setAttribute('aria-current', String(i === index));
        });
      };

      slider.querySelector('[data-hero-prev]').addEventListener('click', () => goTo(index - 1));
      slider.querySelector('[data-hero-next]').addEventListener('click', () => goTo(index + 1));
      dots.forEach((dot, i) => dot.addEventListener('click', () => goTo(i)));

      slider.addEventListener('mouseenter', () => (paused = true));
      slider.addEventListener('mouseleave', () => (paused = false));
      slider.addEventListener('focusin', () => (paused = true));
      slider.addEventListener('focusout', () => (paused = false));
      slider.addEventListener('touchstart', (event) => (touchStart = event.changedTouches[0].clientX), { passive: true });
      slider.addEventListener('touchend', (event) => {
        if (touchStart === null) return;
        const delta = event.changedTouches[0].clientX - touchStart;
        touchStart = null;
        if (Math.abs(delta) >= SWIPE_PX) goTo(index + (delta < 0 ? 1 : -1));
      });

      if (slider.dataset.heroAutoplay !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      setInterval(() => {
        if (!paused && !document.hidden) goTo(index + 1);
      }, AUTOPLAY_MS);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const FEED_PATH = 'collections/all?sort_by=best-selling&section_id=home-products-feed';
    const DARK_SWAPS = [
      ['seed-product-card--light', 'seed-product-card--figma-dark seed-product-card--dark'],
    ];

    const loadFeed = () => {
      if (!window.seedHomeFeed) {
        window.seedHomeFeed = fetch(window.Shopify.routes.root + FEED_PATH)
          .then((response) => (response.ok ? response.text() : ''))
          .then((html) => new DOMParser().parseFromString(html, 'text/html').querySelector('[data-products-feed]'))
          .catch(() => null);
      }
      return window.seedHomeFeed;
    };

    const collectionCache = new Map();
    const loadCollection = (handle) => {
      if (!collectionCache.has(handle)) {
        const job = (async () => {
          let url = new URL(window.Shopify.routes.root + 'collections/' + encodeURIComponent(handle), location.origin);
          const items = [];
          do {
            url.searchParams.set('section_id', 'home-collection-feed');
            const response = await fetch(url);
            if (!response.ok) throw new Error('Collection feed unavailable');
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const feed = doc.querySelector('[data-collection-feed]');
            if (!feed) throw new Error('Collection feed missing');
            items.push(...feed.querySelectorAll('[data-products-track] > .seed-carousel-item'));
            url = feed.dataset.next ? new URL(feed.dataset.next, location.origin) : null;
          } while (url);
          return items;
        })().catch((error) => { collectionCache.delete(handle); throw error; });
        collectionCache.set(handle, job);
      }
      return collectionCache.get(handle);
    };

    const toDark = (body) => {
      body.querySelectorAll('.seed-product-card--light').forEach((card) => {
        DARK_SWAPS.forEach(([from, to]) => {
          card.classList.remove(from);
          card.classList.add(...to.split(' '));
        });
      });
      body.querySelector('.seed-pill-scroller')?.classList.add('seed-pill-scroller--dark');
      body.querySelector('.seed-filter-pills')?.classList.add('seed-filter-pills--dark');
    };

    const bind = (section) => {
      const track = section.querySelector('[data-products-track]');
      const status = section.querySelector('[data-products-status]');
      const pills = section.querySelector('[data-pill-track]');

      section.querySelector('[data-track-prev]')?.addEventListener('click', () =>
        track.scrollBy({ left: -track.clientWidth * 0.8, behavior: 'smooth' }),
      );
      section.querySelector('[data-track-next]')?.addEventListener('click', () =>
        track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' }),
      );

      if (!pills) return;
      const prev = section.querySelector('[data-pill-prev]');
      const next = section.querySelector('[data-pill-next]');
      const setArrow = (button, enabled) => {
        button.hidden = !enabled;
        button.setAttribute('aria-hidden', String(!enabled));
        button.tabIndex = enabled ? 0 : -1;
      };
      const updateArrows = () => {
        setArrow(prev, pills.scrollLeft > 1);
        setArrow(next, pills.scrollLeft + pills.clientWidth < pills.scrollWidth - 1);
      };
      prev.addEventListener('click', () => pills.scrollBy({ left: -pills.clientWidth * 0.7, behavior: 'smooth' }));
      next.addEventListener('click', () => pills.scrollBy({ left: pills.clientWidth * 0.7, behavior: 'smooth' }));
      pills.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();

      const initialItems = [...track.children].map((item) => item.cloneNode(true));
      let requestNumber = 0;
      pills.addEventListener('click', async (event) => {
        const pill = event.target.closest('[data-filter]');
        if (!pill) return;
        const handle = pill.dataset.filter;
        pills.querySelectorAll('[data-filter]').forEach((other) => {
          const active = other === pill;
          other.classList.toggle('seed-filter-pill--active', active);
          other.setAttribute('aria-pressed', String(active));
        });
        section.dataset.filterTouched = 'true';
        const request = ++requestNumber;
        track.setAttribute('aria-busy', 'true');
        try {
          const items = handle ? await loadCollection(handle) : initialItems;
          if (request !== requestNumber) return;
          track.replaceChildren(...items.map((item) => item.cloneNode(true)));
          if (section.dataset.surface === 'dark') toDark(section);
          track.scrollLeft = 0;
          status.textContent = status.dataset.statusTemplate.replace('__N__', items.length);
        } catch (error) {
          if (request === requestNumber) location.assign(window.Shopify.routes.root + 'collections/' + encodeURIComponent(handle));
        } finally {
          if (request === requestNumber) track.removeAttribute('aria-busy');
        }
      });
    };

    document.querySelectorAll('[data-home-products]').forEach((section) => {
      bind(section);
      loadFeed().then((feed) => {
        if (!feed || section.dataset.filterTouched) return;
        const body = section.querySelector('[data-products-body]');
        const fresh = feed.cloneNode(true);
        if (section.dataset.surface === 'dark') toDark(fresh);
        body.replaceChildren(...fresh.childNodes);
        bind(section);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SPEED_PX_PER_SECOND = 45;
    const PER_ROW = 5;
    const MAX_REVIEWS = 50;

    const init = () => document.querySelectorAll('[data-home-reviews]').forEach((section) => {
      if (section.dataset.reviewsReady) return;
      section.dataset.reviewsReady = 'true';
      const templates = [...section.querySelectorAll('template[data-review]')];
      if (!templates.length) return;
      const pool = templates.slice(0, MAX_REVIEWS);
      const observers = [];
      section.addEventListener('shopify:section:unload', () => observers.forEach((observer) => observer.disconnect()), { once: true });
      const total = pool.length;
      const toggle = section.querySelector('[data-reviews-toggle]');
      if (toggle) toggle.addEventListener('click', () => {
        const paused = section.dataset.reviewsPaused !== 'true';
        section.dataset.reviewsPaused = String(paused);
        toggle.setAttribute('aria-pressed', String(paused));
        toggle.textContent = paused ? toggle.dataset.resumeLabel : toggle.dataset.pauseLabel;
      });

      const windowAt = (start) =>
        Array.from({ length: PER_ROW }, (_, i) => pool[(start + i) % total]);

      section.querySelectorAll('[data-reviews-row]').forEach((row, rowIndex) => {
        const track = row.querySelector('[data-reviews-track]');
        const sets = [...row.querySelectorAll('[data-reviews-set]')];
        let start = rowIndex === 0 ? 0 : Math.min(PER_ROW, total) % total;

        const fill = () => {
          const cards = windowAt(start);
          sets.forEach((set, setIndex) => set.replaceChildren(...cards.map((template, cardIndex) => {
            const card = template.content.firstElementChild.cloneNode(true);
            if (section.hasAttribute('data-review-editor') && setIndex === 0 && rowIndex === 0 && cardIndex < total) {
              const attributes = template.getAttribute('data-shopify-editor-block');
              if (attributes) card.setAttribute('data-shopify-editor-block', attributes);
            }
            return card;
          })));
        };

        const measure = () => {
          const cards = sets[0].querySelectorAll('.seed-review-card');
          if (!cards.length) return;
          const first = cards[0].getBoundingClientRect();
          const last = cards[cards.length - 1].getBoundingClientRect();
          const paddingRight = parseFloat(getComputedStyle(sets[0]).paddingRight) || 0;
          const setWidth = last.right - first.left + paddingRight;
          if (!setWidth) return;
          track.style.setProperty('--marquee-duration', `${setWidth / SPEED_PX_PER_SECOND}s`);
          track.style.setProperty('--set-w', `${setWidth}px`);
          sets.forEach((set) => (set.style.width = `${setWidth}px`));
        };

        fill();
        measure();
        if ('ResizeObserver' in window) {
          const observer = new ResizeObserver(measure);
          observer.observe(sets[0]);
          observers.push(observer);
        }

        track.addEventListener('animationiteration', () => {
          start = (start + PER_ROW) % total;
          fill();
        });
      });
    });
    init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-video-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SWIPE_THRESHOLD = 40;
    const mod = (n, m) => ((n % m) + m) % m;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('[data-video-carousel]').forEach((section) => {
      const templates = [...section.querySelectorAll('template[data-video-item]')];
      const track = section.querySelector('[data-video-track]');
      const wrap = section.querySelector('[data-video-wrap]');
      const showAll = section.dataset.showAll === 'true';
      const neighbors = Number(section.dataset.neighbors) || 0;
      const count = templates.length;
      if (!count) return;

      const offsets = showAll
        ? [0, 1]
        : Array.from({ length: neighbors * 2 + 1 }, (_, i) => i - neighbors);
      let activeIndex = 0;
      let near = false;
      const playback = new WeakMap();
      const syncVisibility = () => {
        const rect = section.getBoundingClientRect();
        near = rect.top < window.innerHeight && rect.bottom > 0;
        track.querySelectorAll('[data-video]').forEach((video) => {
          if (!near || document.hidden) video.pause();
          else if (video.dataset.userPaused !== 'true') playback.get(video)?.();
        });
      };

      const goPrev = () => render(mod(activeIndex - 1, count));
      const goNext = () => render(mod(activeIndex + 1, count));

      const setupActive = (slot) => {
        const video = slot.querySelector('[data-video]');
        const controls = slot.querySelector('[data-video-controls]');
        const toggle = slot.querySelector('[data-video-toggle]');
        const mute = slot.querySelector('[data-video-mute]');
        slot.classList.add('seed-video-carousel-item--active');
        controls.hidden = false;
        video.preload = 'none';
        video.muted = true;

        const syncToggle = (paused) => {
          toggle.setAttribute('aria-label', paused ? toggle.dataset.labelPlay : toggle.dataset.labelPause);
          toggle.querySelector('[data-icon-play]').hidden = !paused;
          toggle.querySelector('[data-icon-pause]').hidden = paused;
        };
        const syncMute = () => {
          mute.setAttribute('aria-label', video.muted ? mute.dataset.labelUnmute : mute.dataset.labelMute);
          mute.querySelector('[data-icon-muted]').hidden = !video.muted;
          mute.querySelector('[data-icon-sound]').hidden = video.muted;
        };
        const play = () => {
          if (!near || document.hidden) return;
          if (!video.hasAttribute('src')) video.src = video.dataset.src;
          if (video.readyState === video.HAVE_NOTHING) video.load();
          video.play().catch(() => syncToggle(true));
        };

        toggle.addEventListener('click', () => {
          if (video.paused) {
            video.dataset.userPaused = 'false';
            play();
          } else {
            video.dataset.userPaused = 'true';
            video.pause();
            syncToggle(true);
          }
        });
        mute.addEventListener('click', () => {
          video.muted = !video.muted;
          syncMute();
        });
        if (!showAll) video.addEventListener('ended', goNext);

        video.addEventListener('playing', () => syncToggle(false));
        video.addEventListener('pause', () => syncToggle(true));
        video.addEventListener('error', () => syncToggle(true));
        syncToggle(true);
        syncMute();
        const start = () => { if (!reducedMotion) play(); };
        playback.set(video, start);
        return start;
      };

      function render(index) {
        activeIndex = index;
        const startPlayback = [];
        const slots = offsets.map((offset) => {
          const slot = templates[mod(activeIndex + offset, count)].content.firstElementChild.cloneNode(true);
          if (showAll || offset === 0) startPlayback.push(setupActive(slot));
          return slot;
        });
        track.querySelectorAll('video').forEach((video) => video.pause());
        track.replaceChildren(...slots);
        startPlayback.forEach((start) => start());
      }

      section.querySelector('[data-video-prev]')?.addEventListener('click', goPrev);
      section.querySelector('[data-video-next]')?.addEventListener('click', goNext);

      let dragStartX = null;
      wrap.addEventListener('pointerdown', (event) => (dragStartX = event.clientX));
      wrap.addEventListener('pointercancel', () => (dragStartX = null));
      wrap.addEventListener('pointerup', (event) => {
        if (dragStartX === null || showAll) return;
        const delta = event.clientX - dragStartX;
        dragStartX = null;
        if (delta > SWIPE_THRESHOLD) goPrev();
        else if (delta < -SWIPE_THRESHOLD) goNext();
      });

      render(0);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(syncVisibility, { rootMargin: '0px' }).observe(section);
      }
      window.addEventListener('scroll', syncVisibility, { passive: true });
      document.addEventListener('visibilitychange', syncVisibility);
      window.addEventListener('pageshow', syncVisibility);
      syncVisibility();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-product-section]');
    if (!root) return;

    const sectionId = root.dataset.sectionId;
    const variants = JSON.parse(document.querySelector('[data-product-variants]').textContent);

    const bindGallery = () => {
      const slider = root.querySelector('[data-gallery-slider]');
      if (!slider) return;
      const dots = [...root.querySelectorAll('[data-gallery-dot]')];
      const thumbs = [...root.querySelectorAll('[data-gallery-thumb]')];

      const setActive = (index) => {
        dots.forEach((dot, i) => dot.classList.toggle('pdp-gallery-dot--active', i === index));
        thumbs.forEach((thumb, i) => thumb.classList.toggle('pdp-thumb--active', i === index));
      };
      const scrollToIndex = (index) => {
        slider.scrollTo({ left: index * slider.clientWidth, behavior: 'smooth' });
        setActive(index);
      };

      slider.addEventListener('scroll', () => setActive(Math.round(slider.scrollLeft / slider.clientWidth)), { passive: true });
      dots.forEach((dot, i) => dot.addEventListener('click', () => scrollToIndex(i)));
      thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => scrollToIndex(i)));
    };

    const TIER_QUOTE_QUERY = `mutation TierPriceQuote($merchandiseId: ID!, $quantity: Int!, $country: CountryCode, $language: LanguageCode) @inContext(country: $country, language: $language) {
      cartCreate(input: {lines: [{merchandiseId: $merchandiseId, quantity: $quantity}]}) {
        cart { lines(first: 1) { nodes { quantity cost { totalAmount { amount currencyCode } } } } }
        userErrors { message }
      }
    }`;
    const tierQuoteCache = new Map();
    let variantController;
    let stickyObserver;

    const formatMoney = (cents, format) => {
      const fixed = (cents / 100).toFixed(2);
      const [whole, fraction] = fixed.split('.');
      const group = (value, separator) => value.replace(/\B(?=(\d{3})+(?!\d))/g, separator);
      const replacements = {
        amount: `${group(whole, ',')}.${fraction}`,
        amount_no_decimals: group(String(Math.round(cents / 100)), ','),
        amount_with_comma_separator: `${group(whole, '.')},${fraction}`,
        amount_no_decimals_with_comma_separator: group(String(Math.round(cents / 100)), '.'),
        amount_with_apostrophe_separator: `${group(whole, "'")}.${fraction}`,
      };
      return format.replace(/\{\{\s*(\w+)\s*\}\}/, (match, key) => replacements[key] ?? replacements.amount);
    };

    // Quotes each tier with a throwaway Storefront API cart (tokenless access), exactly like
    // Hydrogen's /api/tier-price: the cart is never attached to the shopper, and its total
    // already includes the Kaching Bundles quantity-break discount.
    const quoteTier = async (grid, quantity) => {
      const key = `${grid.dataset.variantId}:${quantity}:${grid.dataset.country}:${grid.dataset.language}`;
      if (!tierQuoteCache.has(key)) {
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 8000);
        const request = fetch('/api/2026-07/graphql.json', {
          method: 'POST',
          signal: controller.signal,
          credentials: 'omit',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            query: TIER_QUOTE_QUERY,
            variables: {
              merchandiseId: `gid://shopify/ProductVariant/${grid.dataset.variantId}`,
              quantity,
              country: grid.dataset.country || undefined,
              language: grid.dataset.language || undefined,
            },
          }),
        })
          .then((response) => (response.ok ? response.json() : null))
          .then((json) => {
            const result = json?.data?.cartCreate;
            const line = result?.cart?.lines?.nodes?.[0];
            const amount = Number(line?.cost?.totalAmount?.amount);
            if (!line || line.quantity !== quantity || result.userErrors?.length || !Number.isFinite(amount) || amount < 0) return null;
            return Math.round((amount * 100) / quantity);
          })
          .catch(() => null)
          .finally(() => clearTimeout(timeout));
        tierQuoteCache.set(key, request);
      }
      return tierQuoteCache.get(key);
    };

    const bindTiers = (info) => {
      const grid = info.querySelector('[data-tier-grid]');
      if (!grid) return;
      const stepper = info.querySelector('[data-qty-stepper]');
      const qty = info.querySelector('[data-qty-input]');
      const cards = [...grid.querySelectorAll('[data-tier-qty]')];
      const basePrice = Number(grid.dataset.basePrice);

      const select = (card) => {
        if (card.disabled) return;
        cards.forEach((candidate) => {
          const active = candidate === card;
          candidate.classList.toggle('pdp-qty-card--active', active);
          candidate.setAttribute('aria-checked', String(active));
          candidate.tabIndex = active ? 0 : -1;
        });
        if (qty) qty.value = card.dataset.tierQty;
        qty?.dispatchEvent(new Event('change', { bubbles: true }));
      };
      cards.forEach((card) => card.addEventListener('click', () => select(card)));
      grid.addEventListener('keydown', (event) => {
        if (grid.getAttribute('aria-busy') === 'true') return;
        if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const index = cards.indexOf(document.activeElement);
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? cards.length - 1
          : (index + (['ArrowRight', 'ArrowDown'].includes(event.key) ? 1 : -1) + cards.length) % cards.length;
        cards[next].focus();
        select(cards[next]);
      });

      const quantities = grid.dataset.quantities.split(',').map(Number).filter((value) => value > 1);
      Promise.all(quantities.map((quantity) => quoteTier(grid, quantity))).then((unitPrices) => {
        if (!grid.isConnected) return;
        grid.setAttribute('aria-busy', 'false');
        cards.forEach((card) => { card.disabled = false; });
        let hasDiscount = false;
        let bestPrice = basePrice;
        let bestCard;
        quantities.forEach((quantity, index) => {
          const card = grid.querySelector(`[data-tier-qty="${quantity}"]`);
          const unitPrice = unitPrices[index] ?? basePrice;
          const priceEl = card.querySelector('[data-tier-price]');
          priceEl.classList.remove('pdp-qty-card-price--loading');
          priceEl.removeAttribute('aria-hidden');
          priceEl.textContent = formatMoney(unitPrice, grid.dataset.moneyFormat);
          const percentOff = Math.round((1 - unitPrice / basePrice) * 100);
          if (unitPrice < basePrice) hasDiscount = true;
          if (unitPrice < bestPrice) { bestPrice = unitPrice; bestCard = card; }
          if (percentOff > 0) {
            const badge = card.querySelector('[data-tier-badge]');
            badge.textContent = `-${percentOff}%`;
            badge.hidden = false;
          }
        });
        cards.forEach((card) => {
          const ribbon = card.querySelector('.pdp-qty-card-ribbon');
          if (ribbon) ribbon.hidden = card !== bestCard;
        });
        // No tier beats the single-unit price: fall back to the plain stepper, as on Hydrogen.
        if (!hasDiscount) {
          grid.hidden = true;
          if (stepper) stepper.hidden = false;
        }
      });
    };

    const bindStoreDialog = (info) => {
      const dialog = info.querySelector('[data-store-dialog]');
      const opener = info.querySelector('[data-store-dialog-open]');
      if (!dialog || !opener) return;
      const panel = dialog.querySelector('.pdp-store-dialog-panel');
      const map = dialog.querySelector('iframe[data-src]');
      opener.addEventListener('click', () => {
        if (map && !map.src) map.src = map.dataset.src;
        dialog.showModal();
        panel.classList.add('pdp-store-dialog-panel--visible');
      });
      dialog.querySelector('[data-store-dialog-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => {
        panel.classList.remove('pdp-store-dialog-panel--visible');
        opener.focus();
      });
    };

    const bindBuybox = () => {
      const info = root.querySelector('[data-product-info]');
      const qty = info.querySelector('[data-qty-input]');

      if (qty) {
        const max = Number(qty.max) || 99;
        const syncQuantity = () => {
          qty.value = Math.min(max, Math.max(1, Math.floor(Number(qty.value) || 1)));
          const dynamicQuantity = info.querySelector('[data-dynamic-quantity]');
          if (dynamicQuantity) dynamicQuantity.value = qty.value;
          info.querySelectorAll('[data-tier-qty]').forEach((card, index) => {
            const active = Number(card.dataset.tierQty) === Number(qty.value);
            card.classList.toggle('pdp-qty-card--active', active);
            card.setAttribute('aria-checked', String(active));
            card.tabIndex = active || (index === 0 && !info.querySelector(`[data-tier-qty="${qty.value}"]`)) ? 0 : -1;
          });
        };
        qty.addEventListener('change', syncQuantity);
        info.querySelector('[data-qty-minus]').addEventListener('click', () => {
          qty.value = Math.max(1, Number(qty.value) - 1);
          syncQuantity();
        });
        info.querySelector('[data-qty-plus]').addEventListener('click', () => {
          qty.value = Math.min(max, Number(qty.value) + 1);
          syncQuantity();
        });
      }

      bindTiers(info);
      bindStoreDialog(info);

      info.querySelectorAll('[data-option-input]').forEach((input) => {
        input.addEventListener('change', async () => {
          const currentId = info.querySelector('[data-variant-id]')?.value;
          const previous = variants.find((candidate) => String(candidate.id) === currentId);
          const selected = [...(previous?.options || variants[0].options)];
          info.querySelectorAll('[data-option-input]:checked').forEach((el) => { selected[Number(el.dataset.optionPosition) - 1] = el.value; });
          const variant = variants.find((candidate) => candidate.options.every((value, i) => value === selected[i]));
          if (!variant) return;

          variantController?.abort();
          const controller = new AbortController();
          variantController = controller;
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          const requestUrl = new URL(url);
          requestUrl.searchParams.set('section_id', sectionId);
          const buttons = [...root.querySelectorAll('button[type="submit"]')];
          buttons.forEach((button) => { button.disabled = true; });
          info.setAttribute('aria-busy', 'true');
          info.querySelector('[data-variant-alert]')?.remove();
          try {
            const response = await fetch(requestUrl, { signal: controller.signal });
            if (!response.ok) throw new Error('Variant response');
            const markup = new DOMParser().parseFromString(await response.text(), 'text/html');
            const next = markup.querySelector('[data-product-info]');
            if (!next) throw new Error('Missing product information');
            if (controller.signal.aborted) return;
            info.replaceWith(next);
            const nextBar = markup.querySelector('[data-sticky-bar]');
            if (nextBar) root.querySelector('[data-sticky-bar]')?.replaceWith(nextBar);
            window.history.replaceState({}, '', url);
            bindBuybox();
            bindSticky();
            const mediaId = variant.featured_media?.id;
            const slide = mediaId && root.querySelector(`[data-media-id="${mediaId}"]`);
            if (slide) root.querySelector('[data-gallery-slider]').scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
            next.querySelector(`[data-option-position="${input.dataset.optionPosition}"]:checked`)?.focus({ preventScroll: true });
          } catch (error) {
            if (error.name === 'AbortError') return;
            info.querySelectorAll('[data-option-input]').forEach((el) => {
              el.checked = el.value === previous?.options[Number(el.dataset.optionPosition) - 1];
            });
            const message = document.createElement('p');
            message.dataset.variantAlert = '';
            message.setAttribute('role', 'alert');
            message.textContent = root.dataset.variantError;
            info.append(message);
          } finally {
            if (variantController === controller) {
              info.removeAttribute('aria-busy');
              buttons.forEach((button) => { button.disabled = false; });
            }
          }
        });
      });
    };

    const bindSticky = () => {
      const bar = root.querySelector('[data-sticky-bar]');
      const anchor = root.querySelector('.pdp-atc-row');
      if (!bar || !anchor) return;

      stickyObserver?.disconnect();
      stickyObserver = new IntersectionObserver(([entry]) => {
        bar.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
      });
      stickyObserver.observe(anchor);
    };

    bindGallery();
    bindSticky();
    bindBuybox();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-quiz"]) return;
  try {
    
  if (!customElements.get('page-quiz')) {
    // Product tags are written both with and without Lithuanian letters
    // ("virškinimas" / "virskinimas"), so every concern lists each spelling in use.
    const CONCERN_TAGS = {
      energy: ['energija', 'gyvybingumas', 'nuovargis'],
      digestion: ['virškinimas', 'virskinimas', 'žarnynas', 'skrandis'],
      liver: ['kepenys'],
      skin: ['oda'],
      bones: ['kaulai', 'sąnariai'],
      heart: ['širdis', 'sirdis', 'kraujotaka'],
      detox: ['detox', 'detoksikacija'],
      sleep: ['miegas', 'stresas', 'emocinė pusiausvyra'],
      women: ['moterims', 'menopauzė', 'hormonų pusiausvyra', 'hormonų balansas'],
      mind: ['protas', 'koncentracija', 'atmintis'],
      sport: ['sportas', 'sportui', 'raumenys'],
      men: ['vyrams'],
    };
    // The other answers nudge the ranking: a matching product moves up, it is never the only reason to show one.
    const SIGNALS = {
      stress: { tags: ['stresas', 'miegas', 'emocinė pusiausvyra', 'nervų sistema'], weights: { yes: 3, some: 1 } },
      illness: { tags: ['imunitetas'], weights: { often: 3, sometimes: 1 } },
      exercise: { tags: ['sportas', 'sportui', 'raumenys'], weights: { high: 2 } },
      diet: { tags: ['supermaistas', 'supermaisto mišinys'], weights: { no: 2, rarely: 1 } },
    };
    const WOMEN_ONLY_TAGS = ['menopauzė', 'menstruacijos', 'moterų sveikata', 'ciklo reguliavimas'];
    const MEN_ONLY_TAGS = ['vyrams', 'prostata'];
    const MAX_RESULTS = 6;

    // Hand-picked products for every answer, best match first (product handles),
    // chosen from each product's own description. A product that is sold out or
    // unpublished is skipped automatically and shows up again once it is back,
    // so the lists can name it anyway.
    const CONCERN_PRODUCTS = {
      energy: ['energytea', 'fungi-energy-tea-arbata-pakeliuose', 'eliksyras', 'day-magnesium', '10-golden-mumijo-shilajit', 'detox-tea-day-150g', 'fungi-energy-tea', '30-cordyceps', 'creatine-monohydrate-maisto-papildas', 'hawaiian-spirulina-chlorella-4', 'shilajit-mumijo-altai-derva', 'ashwagandha-maisto-papildas', 'chaga-caga-3', '10-matcha-premium-food-grade-arbata', 'mumijo-derva'],
      digestion: ['enzyme-pro', '10-proviotics-gerosios-bakterijos', 'mastika-mastiha', 'zarnyno-svara-kapsulemis', 'detox-tea-night-3', '10-herbal-vinegar-2', 'pelynas-kapsulese', 'balksvuju-gyslociu-seklu-luobeles', 'digestion-tea', '10-paralex-vinegar', 'verminus-5', '20-kiaulpiene-lapu-milteliai', 'zarnyno-svara-verminus', '20-mastika-herbal-vinegar', 'pura'],
      liver: ['kepenims-2', '25-kepenims-copy', 'ciberzole', '10-paralex-vinegar', 'pelynas-kapsulese', '20-kiaulpiene-lapu-milteliai', 'pura', '25-liver-box-kepenims', '30-verminus-kepenims-ciberzole-juodieji-pipirai', '30-paralex-box-organizmo-bei-kepenu-valymui', 'augalu-karalienes'],
      skin: ['hair-skin', '25-women-s-box-moterims', '15-dilgele', 'veido-serumas-active-plant-face-serum-30-ml-2', 'hawaiian-spirulina-chlorella-4', 'ciberzole', 'kuno-sveitiklis-hydra-shine-200-ml', '10-plauku-kauke-hydra-shine-200-ml', '20-aliejine-plauku-kauke-hydra-shine-100-ml', 'l-glycine-maisto-papildas', '20-red-superfood-supermaisto-misinys'],
      bones: ['sanariams', 'ciberzole', 'eliksyras', 'day-magnesium', '15-dilgele', 'juodgrude', 'magnesium-day-night', '10-golden-mumijo-shilajit', 'shilajit-mumijo-altai-derva', 'hair-skin'],
      heart: ['juodasis-cesnakas-2', '20-red-superfood-supermaisto-misinys', 'reishi', 'juodgrude', 'ciberzole', '15-dilgele', 'golden-chai', '30-hemovita-box-kraujui-ir-kraujotakai-1', '30-super-7-fungi-super-grybu-misinys', 'augalu-karalienes', 'eliksyras'],
      detox: ['detox-tea-day-150g', 'detox-tea-night-3', 'zarnyno-svara-kapsulemis', 'pelynas-kapsulese', 'verminus-5', '10-paralex-vinegar', 'zarnyno-svara-verminus', '30-restart-box-organizmo-restartui-detox', '25-detox-box-virskinimui-zarnynui', '20-juodasis-riesutmedis', 'pura', '30-heavyless-box-norintiems-lengvumo-jausmo', 'balksvuju-gyslociu-seklu-luobeles'],
      sleep: ['miegui', 'night-magnesium', 'ashwagandha-maisto-papildas', 'l-glycine-maisto-papildas', '20-rinkinys-miegui', 'reishi', 'magnesium-day-night', 'ashwagandha-root-powder', 'golden-chai'],
      women: ['menopause-maisto-papildas', '15-moterims-2', 'raudoni-dobilai', '10-vitex', 'moters-sveikata-woman-s-health-tea', '10-harmony-vinegar', 'menopause-vinegar-actas-rugstingumas-5', '25-menopause-maisto-papildas-copy', 'raudonuju-dobilu-ziedai-arbata', 'menopause-maisto-papildas-copy', '20-vitex-raudonuju-dobilu-ziedai', '20-moterims-harmony-vinegar', '25-menopause-box-moters-svytejimui'],
      mind: ['smegenims-1', 'lion-s-mane-2', 'energytea', 'fungi-energy-tea-arbata-pakeliuose', 'day-magnesium', 'fungi-energy-tea', '30-super-7-fungi-super-grybu-misinys', '10-golden-mumijo-shilajit', '30-cordyceps', 'detox-tea-day-150g', 'super-7-fungi-1'],
      sport: ['creatine-monohydrate-maisto-papildas', 'hydracreatine-electrolytes-braskiu-skonio-su-saldikliu-maisto-papildas', 'day-magnesium', '30-cordyceps', 'hydracreatine-electrolytes-be-skonio-maisto-papildas', 'magnesium-day-night', '10-golden-mumijo-shilajit', 'hydracreatine-electrolytes-braskiu-skonio-su-saldikliu-maisto-papildas-copy', 'sanariams', 'night-magnesium', 'hawaiian-spirulina-chlorella-4'],
      men: ['vyrams', '10-golden-mumijo-shilajit', '20-golden-mumijo-shilajit-vyrams', '30-cordyceps', 'shilajit-mumijo-altai-derva', 'mumijo-derva', '30-mens-box-vyru-energijai', '20-vyrams-moterims'],
    };
    // The other questions. A "strong" answer always brings its best product into
    // the results; a "weak" one only moves matching products up.
    const SIGNAL_PRODUCTS = {
      stress: { strong: 'yes', weak: 'some', handles: ['ashwagandha-maisto-papildas', 'night-magnesium', '20-rinkinys-miegui', 'reishi', 'ashwagandha-root-powder'] },
      illness: { strong: 'often', weak: 'sometimes', handles: ['20-imunitetui-maisto-papildas', '10-immune-vinegar', 'chaga-caga-3', '25-immune-box-imunitetui', 'reishi', '30-super-7-fungi-super-grybu-misinys', 'juodasis-cesnakas-2', '10-proviotics-gerosios-bakterijos'] },
      exercise: { strong: 'high', weak: '', handles: ['day-magnesium', 'creatine-monohydrate-maisto-papildas', 'hydracreatine-electrolytes-braskiu-skonio-su-saldikliu-maisto-papildas', 'magnesium-day-night'] },
      diet: { strong: 'no', weak: 'rarely', handles: ['eliksyras', 'hawaiian-spirulina-chlorella-4', 'augalu-karalienes', '20-red-superfood-supermaisto-misinys', 'maistiniu-mieliu-dribsniai-parmezano-surio-ir-skrudinto-cesnako-skonio-2', '15-dilgele'] },
    };
    // The same product in another form: only one of each group is shown.
    const SAME_PRODUCT = [
      ['fungi-energy-tea-arbata-pakeliuose', 'fungi-energy-tea'],
      ['eliksyras', 'eliksyras-4'],
      ['hydracreatine-electrolytes-braskiu-skonio-su-saldikliu-maisto-papildas', 'hydracreatine-electrolytes-be-skonio-maisto-papildas', 'hydracreatine-electrolytes-braskiu-skonio-su-saldikliu-maisto-papildas-copy'],
      ['10-golden-mumijo-shilajit', 'shilajit-mumijo-altai-derva', 'mumijo-derva'],
      ['ashwagandha-maisto-papildas', 'ashwagandha-root-powder'],
      ['zarnyno-svara-kapsulemis', 'zarnyno-svara'],
      ['10-plauku-kauke-hydra-shine-200-ml', '20-aliejine-plauku-kauke-hydra-shine-100-ml'],
      ['30-super-7-fungi-super-grybu-misinys', 'super-7-fungi-1'],
      ['raudoni-dobilai', 'raudonuju-dobilu-ziedai-arbata'],
      ['menopause-maisto-papildas', 'menopause-maisto-papildas-copy'],
    ];
    const WOMEN_ONLY_PRODUCTS = ['25-women-s-box-moterims'];
    const MEN_FIRST_PRODUCTS = ['10-golden-mumijo-shilajit', '30-cordyceps'];
    const FETCH_CANDIDATES = 18;
    const MIN_CURATED = 3;
    const STORAGE_KEY = 'quiz-results';
    const EMAIL_STEP = 6;
    const RESULTS_STEP = 7;

    function readStoredAnswers() {
      try {
        const stored = window.localStorage.getItem(STORAGE_KEY);
        return stored ? JSON.parse(stored) : null;
      } catch {
        return null;
      }
    }

    function writeStoredAnswers(answers) {
      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(answers));
      } catch {
        // Storage blocked (private mode) — the quiz still works for this visit.
      }
    }

    function clearStoredAnswers() {
      try {
        window.localStorage.removeItem(STORAGE_KEY);
      } catch {
        // Nothing stored.
      }
    }

    class PageQuiz extends HTMLElement {
      connectedCallback() {
        this.answers = { concerns: [] };
        this.requestId = 0;
        this.steps = Array.from(this.querySelectorAll('[data-quiz-step]'));
        this.progress = this.querySelector('[data-quiz-progress]');
        this.progressBar = this.querySelector('[data-quiz-progress-bar]');
        this.container = this.querySelector('[data-quiz-container]');
        this.results = this.querySelector('[data-quiz-results]');
        this.emailInput = this.querySelector('[data-quiz-email]');
        this.emailSubmit = this.querySelector('[data-quiz-email-submit]');

        this.addEventListener('click', (event) => this.handleClick(event));
        this.emailInput.addEventListener('input', () => {
          this.emailSubmit.disabled = !this.emailInput.value;
        });
        this.emailInput.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' && this.emailInput.value) this.submitEmail();
        });

        const stored = readStoredAnswers();
        if (stored && Array.isArray(stored.concerns)) {
          this.answers = stored;
          this.submitResults();
        } else {
          this.show(0, false);
        }
      }

      handleClick(event) {
        const option = event.target.closest('[data-quiz-option]');
        if (option) {
          const step = option.closest('[data-quiz-step]');
          if ('multi' in step.dataset) {
            this.toggleConcern(step, option);
          } else {
            this.answers[step.dataset.field] = option.dataset.quizOption;
            this.markSelected(step, [option.dataset.quizOption]);
            this.advance(Number(step.dataset.quizStep) + 1);
          }
          return;
        }
        const addAll = event.target.closest('[data-quiz-add-all]');
        if (addAll) return this.addAll(addAll);
        if (event.target.closest('[data-quiz-next]')) return this.advance(2);
        if (event.target.closest('[data-quiz-email-submit]')) return this.submitEmail();
        if (event.target.closest('[data-quiz-skip]')) return this.submitResults();
        if (event.target.closest('[data-quiz-restart]')) return this.restart();
      }

      toggleConcern(step, option) {
        const value = option.dataset.quizOption;
        const concerns = this.answers.concerns || [];
        this.answers.concerns = concerns.includes(value)
          ? concerns.filter((concern) => concern !== value)
          : [...concerns, value];
        this.markSelected(step, this.answers.concerns);
        step.querySelector('[data-quiz-next]').disabled = this.answers.concerns.length === 0;
      }

      markSelected(step, values) {
        step.querySelectorAll('[data-quiz-option]').forEach((button) => {
          const active = values.includes(button.dataset.quizOption);
          button.classList.toggle('quiz-option--selected', active);
          button.setAttribute('aria-pressed', String(active));
        });
      }

      advance(next) {
        // Answers 1–6 are persisted once the diet question is answered, so a
        // returning visitor lands straight on their results.
        if (next === EMAIL_STEP) {
          writeStoredAnswers({
            gender: this.answers.gender || '',
            concerns: this.answers.concerns || [],
            exercise: this.answers.exercise || '',
            stress: this.answers.stress || '',
            illness: this.answers.illness || '',
            diet: this.answers.diet || '',
          });
        }
        this.show(next, true);
      }

      show(step, moveFocus) {
        const isResults = step === RESULTS_STEP;
        this.steps.forEach((element) => {
          element.hidden = Number(element.dataset.quizStep) !== step;
        });
        this.results.hidden = !isResults;
        this.container.classList.toggle('quiz-container--wide', isResults);
        this.progress.hidden = isResults;

        const percent = isResults ? 100 : Math.round((step / 7) * 100);
        this.progress.setAttribute('aria-valuenow', String(percent));
        this.progressBar.style.setProperty('--quiz-progress', `${percent}%`);

        if (moveFocus && !isResults) {
          const heading = this.steps[step] && this.steps[step].querySelector('.quiz-step-question');
          if (heading) heading.focus({ preventScroll: true });
        }
        window.scrollTo({ top: 0 });
      }

      submitEmail() {
        const email = this.emailInput.value.trim();
        if (!email || !this.emailInput.reportValidity()) return;
        // Use Shopify's native submission so consent, CAPTCHA and validation run.
        const form = this.querySelector('.quiz-signup-form');
        form.querySelector('[data-quiz-signup-email]').value = email;
        writeStoredAnswers(this.answers);
        form.requestSubmit();
      }

      async submitResults() {
        const requestId = ++this.requestId;
        this.setLoading(true);
        this.show(RESULTS_STEP, false);

        let entries = await this.curatedResults();
        if (requestId !== this.requestId) return;
        if (entries.length < MIN_CURATED) {
          // Too few hand-picked products can be bought right now: fill up from the tag search.
          const extra = await this.tagResults();
          if (requestId !== this.requestId) return;
          const seen = new Set(entries.map((entry) => entry.handle));
          extra.forEach((entry) => {
            if (entries.length >= MAX_RESULTS || (entry.handle && seen.has(entry.handle))) return;
            seen.add(entry.handle);
            entries.push(entry);
          });
        }

        const grid = this.querySelector('[data-quiz-grid]');
        grid.replaceChildren(...entries.map((entry, index) => this.buildResult(entry, index === 0)));
        grid.hidden = entries.length === 0;
        this.querySelector('[data-quiz-empty]').hidden = entries.length !== 0;
        this.updateAddAll();
        this.setLoading(false);
        this.querySelector('.quiz-results-heading').focus({ preventScroll: true });
      }

      // Ranks the hand-picked products for the given answers. Returns the ranked
      // candidates and, for each strong answer, the products one of which must be shown.
      plan() {
        const answers = this.answers;
        const concerns = (answers.concerns || []).filter((concern) => CONCERN_PRODUCTS[concern]);
        const scores = new Map();
        const entry = (handle) => {
          if (!scores.has(handle)) scores.set(handle, { handle, score: 0, concerns: [], signals: [], order: scores.size });
          return scores.get(handle);
        };
        concerns.forEach((concern) => {
          CONCERN_PRODUCTS[concern].forEach((handle, index) => {
            const item = entry(handle);
            item.score += Math.max(12 - 1.5 * index, 1);
            item.concerns.push(concern);
          });
        });
        const reserved = [];
        Object.entries(SIGNAL_PRODUCTS).forEach(([field, signal]) => {
          const strong = answers[field] === signal.strong;
          const weak = signal.weak !== '' && answers[field] === signal.weak;
          if (!strong && !weak) return;
          signal.handles.forEach((handle) => {
            const item = scores.get(handle);
            if (!item) return;
            item.score += strong ? 3 : 2;
            item.signals.push(field);
          });
          if (strong && reserved.length < 2) reserved.push({ field, handles: signal.handles });
        });
        if (answers.gender === 'male') {
          MEN_FIRST_PRODUCTS.forEach((handle) => { if (scores.has(handle)) scores.get(handle).score += 1.5; });
          if (!concerns.includes('women')) WOMEN_ONLY_PRODUCTS.forEach((handle) => scores.delete(handle));
        }
        const ranked = [...scores.values()].sort((a, b) => b.score - a.score || a.order - b.order);
        return { ranked, reserved, concerns };
      }

      // Picks the products to show from what can be bought. Every chosen concern
      // gets its best product first, the rest is filled so that no single
      // concern takes over, and one place is kept for each strong answer.
      choose(ranked, reserved, isAvailable, concerns) {
        const available = ranked.filter((item) => isAvailable(item.handle));
        const family = (handle) => (SAME_PRODUCT.find((group) => group.includes(handle)) || [handle])[0];
        const must = [];
        reserved.forEach(({ field, handles }) => {
          const handle = handles.find((candidate) => isAvailable(candidate));
          if (handle && !must.some((item) => family(item.handle) === family(handle))) must.push({ handle, field });
        });
        const chosen = [];
        const counts = {};
        const has = (handle) => chosen.some((item) => item.handle === handle);
        const sameShown = (handle) => chosen.some((item) => item.handle !== handle && family(item.handle) === family(handle));
        const fits = (item) => {
          if (sameShown(item.handle)) return false;
          const missingAfter = must.filter((needed) => family(needed.handle) !== family(item.handle) && !has(needed.handle) && !sameShown(needed.handle)).length;
          return chosen.length + 1 + missingAfter <= MAX_RESULTS;
        };
        const take = (item) => {
          chosen.push(item);
          item.concerns.forEach((concern) => { counts[concern] = (counts[concern] || 0) + 1; });
        };

        concerns.forEach((concern) => {
          const item = CONCERN_PRODUCTS[concern].map((handle) => available.find((candidate) => candidate.handle === handle)).find(Boolean);
          if (item && !has(item.handle) && fits(item)) take(item);
        });

        for (;;) {
          let next = null;
          let nextValue = -Infinity;
          available.forEach((item) => {
            if (has(item.handle) || !fits(item)) return;
            const crowding = Math.min(...item.concerns.map((concern) => counts[concern] || 0));
            const value = item.score - 1.5 * crowding;
            if (value > nextValue) { next = item; nextValue = value; }
          });
          if (!next) break;
          take(next);
        }

        chosen.sort((a, b) => b.score - a.score || a.order - b.order);
        must.forEach(({ handle, field }) => {
          if (has(handle) || sameShown(handle)) return;
          const known = ranked.find((item) => item.handle === handle);
          chosen.push(known || { handle, score: 0, concerns: [], signals: [field], order: 0 });
        });
        return chosen;
      }

      async fetchCard(handle) {
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        try {
          const response = await fetch(`${root}products/${encodeURIComponent(handle)}?section_id=quiz-product-card`);
          if (!response.ok) return null;
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          return doc.querySelector('[data-quiz-result]');
        } catch {
          return null;
        }
      }

      async curatedResults() {
        const { ranked, reserved, concerns } = this.plan();
        // Ask for the products tied to strong answers, the best product of every
        // chosen concern, its runner-up, then the best-ranked rest.
        const handles = [...new Set([
          ...reserved.flatMap((signal) => signal.handles.slice(0, 2)),
          ...concerns.map((concern) => CONCERN_PRODUCTS[concern][0]),
          ...concerns.map((concern) => CONCERN_PRODUCTS[concern][1]),
          ...ranked.map((item) => item.handle),
        ].filter(Boolean))].slice(0, FETCH_CANDIDATES);
        const cards = new Map();
        await Promise.all(handles.map(async (handle) => { cards.set(handle, await this.fetchCard(handle)); }));
        return this.choose(ranked, reserved, (handle) => Boolean(cards.get(handle)), concerns).map((item) => ({
          handle: item.handle,
          element: cards.get(item.handle),
          reasons: [
            ...item.concerns.map((concern) => this.concernLabel(concern)),
            ...item.signals.map((field) => this.signalLabel(field)),
          ].filter(Boolean),
        }));
      }

      // Fallback: products found by their tags, ranked against every answer.
      async tagResults() {
        const concerns = (this.answers.concerns || []).filter((concern) => CONCERN_TAGS[concern]);
        const signals = Object.entries(SIGNALS)
          .map(([field, signal]) => ({ field, tags: signal.tags, weight: signal.weights[this.answers[field]] || 0 }))
          .filter((signal) => signal.weight > 0);
        // Multi-word tags are only used for ranking; the search query keeps to single words.
        const queryTags = [...new Set([
          ...concerns.flatMap((concern) => CONCERN_TAGS[concern]),
          ...signals.flatMap((signal) => signal.tags),
        ].filter((tag) => !tag.includes(' ')))];
        const query = queryTags.length ? queryTags.map((tag) => `tag:${tag}`).join(' OR ') : '*';
        const params = new URLSearchParams({
          q: query,
          type: 'product',
          'options[prefix]': 'none',
          section_id: 'page-quiz-results',
        });

        let candidates = [];
        try {
          const response = await fetch(`${this.dataset.searchUrl}?${params}`);
          if (!response.ok) throw new Error('Quiz results unavailable');
          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          candidates = [...doc.querySelectorAll('[data-quiz-results-grid] [data-quiz-result]')];
        } catch {
          candidates = [];
        }
        return this.rank(candidates, concerns, signals).map((item) => ({
          handle: item.element.dataset.handle || '',
          element: item.element,
          reasons: [
            ...item.matchedConcerns.map((concern) => this.concernLabel(concern)),
            ...item.matchedSignals.map((signal) => this.signalLabel(signal.field)),
          ].filter(Boolean),
        }));
      }

      // Scores every candidate: each chosen concern it covers counts most, the
      // stress / illness / exercise / diet answers break ties. Products meant
      // for the other gender are left out unless that concern was picked.
      rank(candidates, concerns, signals) {
        const gender = this.answers.gender;
        const scored = [];
        candidates.forEach((element, order) => {
          const tags = new Set((element.dataset.tags || '').split('|').map((tag) => tag.trim()).filter(Boolean));
          const has = (list) => list.some((tag) => tags.has(tag));
          // Menopause products are only offered when the hormones / menopause concern was picked.
          if (tags.has('menopauzė') && !concerns.includes('women')) return;
          if (gender === 'male' && !concerns.includes('women') && has(WOMEN_ONLY_TAGS) && !has(MEN_ONLY_TAGS)) return;
          if (gender === 'female' && !concerns.includes('men') && has(MEN_ONLY_TAGS) && !tags.has('moterims')) return;
          const matchedConcerns = concerns.filter((concern) => has(CONCERN_TAGS[concern]));
          const matchedSignals = signals.filter((signal) => has(signal.tags));
          if (concerns.length > 0 && matchedConcerns.length === 0 && matchedSignals.length === 0) return;
          const score = matchedConcerns.length * 10 + matchedSignals.reduce((sum, signal) => sum + signal.weight, 0);
          scored.push({ element, order, score, matchedConcerns, matchedSignals });
        });
        scored.sort((a, b) => b.score - a.score || a.order - b.order);
        return scored.slice(0, MAX_RESULTS);
      }

      buildResult(entry, isBest) {
        const node = document.importNode(entry.element, true);
        if (entry.reasons.length > 0) {
          const why = document.createElement('p');
          why.className = 'quiz-result-why';
          why.textContent = `${this.dataset.labelWhy} ${entry.reasons.join(', ')}`;
          node.prepend(why);
        }
        if (isBest) {
          node.classList.add('quiz-result--best');
          const label = document.createElement('span');
          label.className = 'quiz-result-best-label';
          label.textContent = this.dataset.labelBest;
          node.prepend(label);
        }
        return node;
      }

      signalLabel(field) {
        return this.dataset[`reason${field[0].toUpperCase()}${field.slice(1)}`] || '';
      }

      // Variant ids of the shown products that can go straight into the cart
      // (one variant, in stock). Products with options keep their own link.
      addableIds() {
        return [...this.querySelectorAll('[data-quiz-grid] form[data-add-to-cart] input[name="id"]')]
          .map((input) => Number(input.value))
          .filter((id) => id > 0);
      }

      updateAddAll() {
        const wrap = this.querySelector('[data-quiz-add-all-wrap]');
        const button = wrap.querySelector('[data-quiz-add-all]');
        const note = wrap.querySelector('[data-quiz-add-all-note]');
        const count = this.addableIds().length;
        const shown = this.querySelectorAll('[data-quiz-grid] [data-quiz-result]').length;
        wrap.hidden = count < 2;
        button.disabled = false;
        button.textContent = `${this.dataset.labelAddAll} (${count})`;
        note.textContent = count < shown ? this.dataset.noteOptions : '';
        note.hidden = note.textContent === '';
      }

      // One request adds every shown product, then the cart drawer opens with
      // the result. The single "Į krepšelį" buttons on the cards keep working.
      async addAll(button) {
        const ids = this.addableIds();
        if (ids.length === 0 || button.disabled) return;
        const drawer = window.SeedCartDrawer;
        if (drawer && !drawer.beginMutation()) return;
        const note = this.querySelector('[data-quiz-add-all-note]');
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const label = button.textContent;
        button.disabled = true;
        button.textContent = this.dataset.labelAdding;
        try {
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: ids.map((id) => ({ id, quantity: 1 })),
              sections: 'cart-drawer',
              sections_url: window.location.pathname,
            }),
          });
          const json = await response.json();
          if (!response.ok) throw new Error(json.description || json.message || '');
          if (!drawer) {
            window.location.href = `${root}cart`;
            return;
          }
          if (!drawer.render(json.sections && json.sections['cart-drawer'])) await drawer.refresh();
          drawer.open(button);
        } catch (error) {
          note.textContent = (error && error.message) || this.dataset.errorAddAll;
          note.hidden = false;
        } finally {
          if (drawer) drawer.endMutation();
          button.disabled = false;
          button.textContent = label;
        }
      }

      concernLabel(concern) {
        const option = this.querySelector(`[data-field="concerns"] [data-quiz-option="${concern}"] span`);
        return option ? option.textContent.trim() : '';
      }

      setLoading(isLoading) {
        this.querySelector('[data-quiz-loading]').hidden = !isLoading;
        this.querySelector('[data-quiz-results-body]').hidden = isLoading;
      }

      restart() {
        this.requestId++;
        clearStoredAnswers();
        this.answers = { concerns: [] };
        this.emailInput.value = '';
        this.emailSubmit.disabled = true;
        this.steps.forEach((step) => {
          this.markSelected(step, []);
          const next = step.querySelector('[data-quiz-next]');
          if (next) next.disabled = true;
        });
        this.querySelector('[data-quiz-grid]').innerHTML = '';
        this.querySelector('[data-quiz-add-all-wrap]').hidden = true;
        this.show(0, true);
      }
    }

    customElements.define('page-quiz', PageQuiz);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-related"]) return;
  try {
    
  (() => {
    const bindCarousel = (wrapper) => {
      const track = wrapper.querySelector('[data-carousel-track]');
      const scrollByViewport = (direction) => track.scrollBy({ left: direction * track.clientWidth * 0.8, behavior: 'smooth' });
      wrapper.querySelector('[data-carousel-prev]').addEventListener('click', () => scrollByViewport(-1));
      wrapper.querySelector('[data-carousel-next]').addEventListener('click', () => scrollByViewport(1));
      track.addEventListener('scroll', () => track.classList.toggle('seed-carousel-track--scrolled', track.scrollLeft > 20), { passive: true });
    };

    document.querySelectorAll('[data-related-section]').forEach(async (section) => {
      const wrapper = section.querySelector('[data-related-url]');
      const track = wrapper.querySelector('[data-carousel-track]');
      if (track.children.length === 0) {
        const response = await fetch(wrapper.dataset.relatedUrl);
        if (!response.ok) return;
        const markup = new DOMParser().parseFromString(await response.text(), 'text/html');
        const next = markup.querySelector('[data-carousel-track]');
        if (!next || next.children.length === 0) return;
        track.innerHTML = next.innerHTML;
      }
      section.hidden = false;
      bindCarousel(wrapper);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  const bind = () => {
    const section = document.getElementById('reviews');
    const app = section?.querySelector('.pdp-reviews-app');
    if (!app || app.dataset.reviewNavigationBound) return;
    app.dataset.reviewNavigationBound = 'true';
    const loading = app.querySelector('.pdp-reviews-loading');
    const update = () => {
      const ready = Boolean(app.querySelector('.alr-wh-comp-text-content, .alr-wh-review-box, [data-status="initialized"]'));
      app.setAttribute('aria-busy', String(!ready));
      if (loading) loading.hidden = ready;
      if (ready) observer.disconnect();
    };
    const observer = new MutationObserver(update);
    observer.observe(app, {childList: true, subtree: true, attributes: true, attributeFilter: ['data-status']});
    update();
    const navigate = event => {
      const rating = event.target.closest('.alireviews-review-star-rating');
      if (!rating || section.contains(rating)) return;
      if (event.type === 'keydown' && !['Enter', ' '].includes(event.key)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      section.scrollIntoView({block: 'start', behavior: 'instant'});
      const heading = section.querySelector('h2');
      if (heading) {
        heading.setAttribute('tabindex', '-1');
        heading.focus({preventScroll: true});
      }
    };
    document.addEventListener('click', navigate, true);
    document.addEventListener('keydown', navigate, true);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind, {once: true});
  else bind();
  document.addEventListener('shopify:section:load', bind);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-reviews-row]').forEach((row) => {
    const track = row.querySelector('.seed-reviews-track');
    const set = row.querySelector('.seed-reviews-set');
    const PX_PER_SECOND = 40;

    const measure = () => {
      const width = set.getBoundingClientRect().width;
      track.style.setProperty('--set-w', `${width}px`);
      track.style.setProperty('--marquee-duration', `${Math.max(20, width / PX_PER_SECOND)}s`);
    };

    measure();
    new ResizeObserver(measure).observe(set);
  });

  } catch(e) { console.error(e); }
})();
})();
